import React from 'react'
import FormGranularStepsPreview from './FormGranularStepsPreview'
import { useSelector } from 'react-redux'
import CardsInformation from '../CardsInformation/CardsInformation'
import FormWorkedExamplesPreview from './FormWorkedExamplesPreview'
import FormGrowthGoalsPreview from './FormGrowthGoalsPreview'

const FormPreview = ({ previewType = 'create' }) => {
  const lcs = useSelector((state) => state?.dr?.form?.lcs || [])
  const workedExamples = useSelector((state) => state?.dr?.form?.workedExamples || [])
  const growthGoals = useSelector((state) => state?.dr?.form?.growthGoals || [])

  return (
    <div className='max-h-screen-modal-content overflow-auto' >
      <div className='sticky top-0px left-0px bg-background w-full z-12'>
        <CardsInformation />
      </div>
      { ['create', 'lcs'].includes(previewType) && <FormGranularStepsPreview lcs={lcs} /> }
      { ['create', 'workedExamples'].includes(previewType) && <FormWorkedExamplesPreview workedExamples={workedExamples} /> }
      { ['create', 'growthGoals'].includes(previewType) && <FormGrowthGoalsPreview growthGoals={growthGoals} /> }
    </div>
  )
}

export default FormPreview